import { FeatureToggle, PiletFeatureToggleApi, createPiletFeatureToggleApi } from "@piral/feature-management";

export interface OpenCakPiletFeatureToggleApi extends PiletFeatureToggleApi {}

export const openCakToggles = (
  apiBasePath: string,
  allFeaturesToggles: FeatureToggle[]
): OpenCakPiletFeatureToggleApi => ({
  ...createPiletFeatureToggleApi(apiBasePath, allFeaturesToggles)
});
